import { useState } from "react";
import { autoUpdate, flip, FloatingFocusManager, offset, shift, useDismiss, useFloating, useInteractions } from "@floating-ui/react";
import { Localization } from "@viamap/viamap2-common";
import { GlassButton } from "src/components/GlassButtons";
import { MIBIcon } from "src/componentsUtils/MIBIcon";
import { floatingBoundaryMiddleware, MITFloatingPortal, useFloatingPortalContext } from "src/componentsUtils/PortalHelpers";
import "./PLATable.css";

export function PLAFilterButton(props: { active: boolean; disabled?: boolean; className: string; title: string; onClick: () => void; onClear: () => void }) {
   const [open, setOpen] = useState(false);
   const { root } = useFloatingPortalContext();
   const { refs, floatingStyles, context } = useFloating({
      open: open && props.active,
      onOpenChange: setOpen,
      placement: "bottom-end",
      strategy: "fixed",
      whileElementsMounted: autoUpdate,
      middleware: [offset(6), ...(root != null ? floatingBoundaryMiddleware(root) : [flip({ padding: 8 }), shift({ padding: 8 })])]
   });
   const { getFloatingProps } = useInteractions([useDismiss(context)]);

   return <>
      <span ref={refs.setReference} style={{ display: "inline-flex" }}>
         <GlassButton
            className={props.className}
            title={props.title}
            aria-label={props.title}
            aria-pressed={props.active}
            disabled={props.disabled}
            onClick={(event) => {
               event.stopPropagation();
               setOpen(false);
               props.onClick();
            }}
            onContextMenu={(event) => {
               if (!props.active) return;
               event.preventDefault();
               event.stopPropagation();
               setOpen(true);
            }}
         ><MIBIcon icon="spatialFilter" /></GlassButton>
      </span>
      {open && props.active ? <MITFloatingPortal>
         <FloatingFocusManager context={context} modal={false}>
            <div ref={refs.setFloating} style={floatingStyles} className="pla-filter-clear-menu" {...getFloatingProps()}>
               <GlassButton onClick={(event) => {
                  event.stopPropagation();
                  setOpen(false);
                  props.onClear();
               }}>{Localization.getText("Clear filter")}</GlassButton>
            </div>
         </FloatingFocusManager>
      </MITFloatingPortal> : null}
   </>;
}
